import * as Sentry from '@sentry/browser'

/**
 * Sets the database context in Sentry
 */
export function setDatabaseContext(
  databaseId: string | null | undefined,
): void {
  if (databaseId) {
    Sentry.setContext('database', {
      id: databaseId,
    })

    // Also set as a tag for easier filtering
    Sentry.setTag('database_id', databaseId)
  } else {
    // Clear app context when navigating away from app-specific pages
    Sentry.setContext('database', null)
    Sentry.setTag('database_id', null)
  }
}

/**
 * Sets organization context in Sentry
 * Useful for tracking errors by organization
 */
export function setOrganizationContext(
  orgId: string | null | undefined,
  orgName?: string | null,
): void {
  if (orgId) {
    Sentry.setContext('organization', {
      org_id: orgId,
      org_name: orgName || undefined,
    })

    // Also set as a tag for easier filtering
    Sentry.setTag('org_id', orgId)
  } else {
    // Clear organization context
    Sentry.setContext('organization', null)
    Sentry.setTag('org_id', null)
  }
}

/**
 * Clears all custom contexts
 * Useful when transitioning between major app sections
 */
export function clearCustomContexts(): void {
  Sentry.setContext('app', null)
  Sentry.setContext('organization', null)

  Sentry.setTag('app_id', null)
  Sentry.setTag('org_id', null)
}
